import React from 'react';
import { Link } from '@reach/router';
import { url, isPartiallyActive, isActive } from 'js/services/Network';

export default () => (
  <>
    <Link to={url('home-page')} getProps={isActive}>
      Dashboard
    </Link>
    <Link to={url('admin-dashboard-page', { path: 'users' })} getProps={isPartiallyActive}>
      Users
    </Link>
    <Link to={url('admin-dashboard-page', { path: 'items' })} getProps={isPartiallyActive}>
      Items
    </Link>
    <Link to={url('admin-dashboard-page', { path: 'tokens' })} getProps={isPartiallyActive}>
      Tokens
    </Link>
    <Link to={url('admin-dashboard-page', { path: 'orders' })} getProps={isPartiallyActive}>
      Orders / Offers
    </Link>
    <Link to={url('admin-dashboard-page', { path: 'shipments' })} getProps={isPartiallyActive}>
      Shipments
    </Link>
    <Link to={url('admin-dashboard-page', { path: 'transactions' })} getProps={isPartiallyActive}>
      Transactions
    </Link>
    <Link to={url('admin-dashboard-page', { path: 'credit_cards' })} getProps={isPartiallyActive}>
      Credit cards
    </Link>
    <Link to={url('admin-dashboard-page', { path: 'bank_accounts' })} getProps={isPartiallyActive}>
      Bank accounts
    </Link>
    <Link to={url('admin-dashboard-page', { path: 'used_links' })} getProps={isPartiallyActive}>
      Used links
    </Link>
    <Link to={url('admin-dashboard-page', { path: 'mseller_list' })} getProps={isPartiallyActive}>
      Mseller List
    </Link>
  </>
);
